// Primitive (upload) audio node is deprecated: media uploads now go through the
// unified `upload` node. This file is kept only so existing imports keep working
// and any legacy/primitive audio node renders the Transform UI instead.
export { AudioTransform as AudioPrimitive } from './transform';
